import { Component, Input } from '@angular/core';
import { MyErrorStateMatcher } from '../../../pages/edit-threat/utilities/edit-threat.error-matcher';
import { UntypedFormControl } from '@angular/forms';

@Component({
  moduleId: module.id,
  selector: 'app-tlm-form-control-input-no-error',
  templateUrl: './form-control-input-no-error.component.html'
})
export class FormControlInputNoErrorComponent {
  @Input() fc: UntypedFormControl;
  @Input() label: string;
  @Input() componentId: string;
  @Input() matAppearance: string;
}
